__turbopack_context__.v({
  "above-breakpoint-overlay": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__above-breakpoint-overlay",
  "actions": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__actions",
  "avatar": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__avatar",
  "avatar-image": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__avatar-image",
  "avatar-image-loaded": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__avatar-image-loaded",
  "caption": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__caption",
  "handle": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__handle",
  "sheet": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__sheet",
  "title": "CelloReferralUpgradeDialog-module-scss-module__MOBZ3G__title",
});
